import { useMutation } from '@provision/graphql-client';
import { useCallback } from 'react';
import {
  CustomSignupLinkIntervalUnit,
  GENERATE_CUSTOM_SIGNUP_LINK_MUTATION,
  GenerateCustomSignupLinkMutationResponse,
  GenerateCustomSignupLinkMutationVariables,
} from 'src/graphql/entities/custom-signup-link/custom-signup-link.operations';

interface GenerateCustomSignupLinkInput {
  addressId: string;
  partnerId: number;
  partnerProductId: string;
  amountCents: number;
  intervalUnit: CustomSignupLinkIntervalUnit;
  intervalCount: number;
  cancelUrl?: string;
  successUrl?: string;
  disableLink?: boolean;
}

export const useGenerateCustomSignupLink = () => {
  const [generateCustomSignupLinkMutation, { loading: isGeneratingLink }] = useMutation<
    GenerateCustomSignupLinkMutationResponse,
    GenerateCustomSignupLinkMutationVariables
  >(GENERATE_CUSTOM_SIGNUP_LINK_MUTATION);

  const generateCustomSignupLink = useCallback(
    async ({
      addressId,
      partnerId,
      partnerProductId,
      amountCents,
      intervalUnit,
      intervalCount,
      cancelUrl,
      successUrl,
      disableLink,
    }: GenerateCustomSignupLinkInput) => {
      const { data } = await generateCustomSignupLinkMutation({
        variables: {
          input: {
            addressId,
            partnerId,
            partnerProductId,
            amountCents,
            intervalUnit,
            intervalCount,
            cancelUrl,
            successUrl,
            disableLink,
          },
        },
      });

      const url = data?.generateCustomMembershipCheckoutUrl?.url;

      if (!url) {
        throw new Error('Unable to generate a checkout URL.');
      }

      return {
        url,
      };
    },
    [generateCustomSignupLinkMutation],
  );

  return {
    generateCustomSignupLink,
    loading: isGeneratingLink,
  };
};
